export enum ContentControlledEventActionEnum {
  // Effects actions
  Empty = 0,
  Cut = 1,
  BlackRect,
  BlurRect,
  PixelateRect,
  BlackScreen,
  BlurScreen,
  PixelateScreen,
  FreezeFrame,
  PixelateOval,
  BlurOval,
  BlackOval,
  Mute = 100,
  Beep,
  // Subtitles actions
  EditSubtitles = 200,
  RemoveSubtitles = 201,

  // Video Clipping actions. These are inserted into the timeline, but not cut.
  VideoClip = 300,

  // Other actions
  Approve = 9999,
}
